import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, makeStyles, mergeClasses, Text } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles } from '../../../common/hooks';

const useStyles = makeStyles({
  modalSurface: {
    maxWidth: '416px',
    width: '100%',
  }
});

interface PassScrubbingModalProps {
  onCancelButtonClicked(): void;
  onSaveButtonClicked(): void;
}

const PassScrubbingModalImpl: React.FC<PassScrubbingModalProps> = (props) => {
  const {
    onCancelButtonClicked,
    onSaveButtonClicked,
  } = props;

  const commonStyles = useCommonStyles();
  const styles = useStyles();

  return (
    <Dialog
      open
      onOpenChange={(_, data) => {
        if (!data.open) onCancelButtonClicked();
      }}
    >
      <DialogSurface
        className={mergeClasses(commonStyles.modalSurface, styles.modalSurface)}
      >
        <DialogBody className={commonStyles.modalBody}>
          <DialogTitle
            action={(
              <Button
                title='close'
                appearance='transparent'
                icon={<DismissRegular />}
                onClick={onCancelButtonClicked}
              />
            )}
          >
            Advance to judging?
          </DialogTitle>
          <DialogContent>
            <Text as='p'>
              Passing a nomination advances it to judging. Are you sure you want to continue?
            </Text>
          </DialogContent>
          <DialogActions>
            <Button
              appearance='secondary'
              onClick={() => onCancelButtonClicked()}
            >
              Cancel
            </Button>
            <Button
              appearance='primary'
              onClick={() => onSaveButtonClicked()}
            >
              Save
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export const PassScrubbingModal = observer(PassScrubbingModalImpl);
